export default {
  loading: 'Ładowanie...',
  categories: {
    basic: 'Podstawowe',
    object: 'Obiekty',
    symbol: 'Symbole',
    arrow: 'Strzałki',
    flowchart: 'Schematy blokowe',
    animal: 'Zwierzęta',
    game: 'Karty i szachy',
    dialog_balloon: 'Dymki dialogowe',
    electronics: 'Elektronika',
    math: 'Matematyczne',
    music: 'Muzyka',
    misc: 'Różne',
    raphael_1: 'raphaeljs.com zestaw 1',
    raphael_2: 'raphaeljs.com zestaw 2'
  },
  buttons: [
    {
      title: 'Biblioteka kształtów'
    }
  ]
}